module.exports = __webpack_public_path__ + "img/code_circle.d9ff191c.png";